<template>
  <div class="commentWrapper">
    <Score :gameId="gameId"></Score>
    <div class="myComment">
      <h2>我的评价</h2>
      <div class="thumbBox">
        <img v-if="isThumbed" class="thumb" @click="goThumb" src="~assets/images/game/thumb.png" alt="">
        <img v-else class="thumb" src="~assets/images/game/thumbed.png" alt="">
        <span class="thumbNum">{{myComment.ups}}</span>
      </div>
      <div class="user">
        <img v-lazy="myComment.avatar" :key="myComment.avatar" alt="" class="avatar">
        <div class="commentInfo">
          <h3>{{myComment.username}}</h3>
          <Rate disabled :value.sync="myComment.score"></Rate>
          <div class='testDiv'>
            <div> {{myComment.content}} </div>
          </div>
          <div class="operate">
            <div class="dateAndReply"><span class="date">2-21</span>&nbsp;&nbsp;<span class="reply">回复</span></div>
            <img src="~assets/images/game/moreOperate.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="playerComment">
      <h2>玩家评价</h2>
      <div class="threeComment">
        <div class="user" v-for="item in playerComments" :key="item.commentId">
          <img v-lazy="item.avatar" :key="item.avatar" alt="" class="avatar">
          <div class="commentInfo">
            <h3>{{item.username}}</h3>
            <Rate disabled :value.sync="item.score"></Rate>
            <div class='testDiv'>
              <div> {{item.content}} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState,mapMutations } from 'vuex'
import Score from '@/components/gamebox/score'
import { Rate } from 'iview'
export default {
  props:['gameId'],
  data(){
    return {
      myComment:null,
      isThumbed:false
    }
  },
  components: {
    Score,
    Rate
  },
  computed:{
    ...mapState({
      scrollTop:state => state.game.scrollTop,
    })
  },
  created(){
    // moduleType,resourceId,uuid
    // 查看我的评价
    this.$http.post('http://easymock.233wei.cn/mock/5e3b7af07967af073af3f90a/comment/queryMyComment#!method=post').then(res => {
      if(res.data.return_code == 200){
        this.myComment = res.data.data
			}     
    })
  },
  mounted(){
    document.body.scrollTop = this.scrollTop
  },
  methods:{ 
    ...mapMutations([
      'game/setScrollTop'
    ]),
    goThumb(){
      this.isThumbed = true
    },
    handleScroll(){
    }
  },
  destroyed(){
  }
}
</script>
<style>
  .ivu-progress-bg{
    height: 0.03rem !important;
    background-color:#808080 !important;
  }
  .ivu-rate-star{
    margin: 0.01rem !important;
  }
</style>
<style lang="less" scoped>
.commentWrapper{
  h2{
    font-size:0.17rem;
    font-weight:600;
    color: #262626;
    line-height:0.23rem;
    position: relative;
  }
  .myComment{
    padding: 0.21rem 0.17rem;
    background: #fff;
    margin-top: 0.08rem;
    position: relative;
    .thumbBox{
      position: absolute;
      top: 0.6rem; right: 0.17rem;
      color: #666;
      font-size: 0.14rem;
      height: 0.17rem;
      .thumb{ 
        width: 0.17rem;
        height: 0.17rem;
        vertical-align: middle;
      }
      .thumbNum{
        display: inline-block;
        line-height: 0.17rem;
        vertical-align: middle;
        margin-left: 0.02rem;
      }
    }
    .user{
      display: flex;
      padding: 0.16rem 0;
      .avatar{
        width: 0.33rem;
        height: 0.33rem;
        border-radius: 50%;
      }
      .commentInfo{
        margin-left: 0.08rem;
        h3{
          font-size:0.15rem;
          font-weight:500;
          color: #1C1C1C;
        }
        .testDiv{
          // height: 0.94rem;
            width: 2.96rem;
            // height: 0.93rem;
            font-size: 0.17rem;
            line-height: 0.25rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            margin:0.08rem 0 ;
        }
        .operate{
          .dateAndReply{
            font-size:0.13rem;
            width: 0.6rem;
            float: left;
            .date{
              color: #999;
            }
            .reply{
              color: #333;
            }
          }
          >img{
            float: right;
            width: 0.17rem;
            height: 0.17rem;
          }
        }
        .ivu-rate{
          font-size: 0.13rem !important;
          
        }
        .ivu-rate-star{
          position:static !important;
          margin: 0.04rem !important;
        }
        .descript{
          height: 0.92rem;
          margin-top: 0.13rem;
        }
      }
    }
    .seeAll{
      height:0.56rem;
      line-height:0.56rem;
      text-align: center;
      font-size:0.16rem;
      color: #666666;
      img{
        width: 0.07rem;
        height: 0.13rem;
        margin-left: 0.08rem;
      }
    }
  }
  .playerComment{
    padding-bottom: 0.88rem; 
  }
}
</style>